<div class="container">
  <p class="text-center fs-3">Tests angular. Esta pagina se carga de forma lazy, solo cuando se selcciona</p>
  <p class="text-center fs-5">Dato estatico desde route: {{datoEstatico}}</p>
  <p class="text-center fs-5">No uso resolvers para dinamico porque si se invoca desde el propio componente no vuelve a invocar los resolvers</p>
  <p class="text-center fs-5">Dato dinamico  y queryParam: {{datoDinamico}}</p>

  <a [routerLink]="['/tests/angular']" [queryParams]="{ id: 2222 }" routerLinkActive="active">Pulsa aqui para invocar con queryparam</a><p></p>
  <button class="btn btn-secondary" (click)="reload()"> Reload </button><p></p>
  <a [routerLink]="['/acercade']"  routerLinkActive="active">Acerca</a>
  <router-outlet></router-outlet>



  <P></P><label for="tipo_seleccion">Selecciona un mecanismo de seleccion de usuario:</label>
  <select [formControl]="ctrlTipoSeleccion" id="tipo_seleccion">
    <option value="">-- Selecciona --</option>
    @for (option of options; track option) {
      <option [value]="option.value">
        {{ option.label }}
      </option>
    }
  </select>


  <div class="row">
    <div class="mat-elevation-z8 my-3">
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="usuario_id">
          <th mat-header-cell *matHeaderCellDef>Usuario ID</th>
          <td mat-cell *matCellDef="let usuario "> {{ usuario.usuario_id}} </td>
        </ng-container>
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let usuario "> {{ usuario.nombre}} </td>
        </ng-container>
        <ng-container matColumnDef="apellidos">
          <th mat-header-cell *matHeaderCellDef>Apellidos</th>
          <td mat-cell *matCellDef="let usuario "> {{usuario.apellidos}} </td>
        </ng-container>
        <ng-container matColumnDef="direccion">
          <th mat-header-cell *matHeaderCellDef>Direccion</th>
          <td mat-cell *matCellDef="let usuario "> {{usuario.direccion}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row (click)="clickedRow(row)" [class.demo-row-is-clicked]="clickedRowSelected(row)"  *matRowDef="let row; columns: columnsToDisplay"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"></mat-paginator>
    </div>
  </div>
  <div>
    <input id="name" type="text" [formControl]="name" placeholder="Type your name here" style="display: inline-block;"/>
    <button type="button" (click)="name.setValue('Buenas')" style="display: inline-block;">Update name</button>
  </div>

  <p>Hello {{ name.value }}!</p>
  <p>Ejemplo de form group reactivo</p>
  <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
    <label for="first-name">First name:</label>
    <input id="first-name" formControlName="firstName" placeholder="First Name">
    <label for="last-name">Last name:</label>
    <input id="last-name" formControlName="lastName" placeholder="Last Name">
    <button type="submit" [disabled]="!profileForm.valid">Submit</button>
    <p>First Name: {{ profileForm.get('firstName')?.value }} Last Name: {{ profileForm.get('lastName')?.value }} Form Valid: {{ profileForm.valid }}</p>
    <p>Form Value: {{ profileForm.value | json }}
      Form Status: {{ profileForm.status }}
      Form Errors: {{ profileForm.errors | json }}
      Form Pristine: {{ profileForm.pristine }}
      Form Dirty: {{ profileForm.dirty }}
      Form Touched: {{ profileForm.touched }}
      Form Untouched: {{ profileForm.untouched }}
    Form Pending: {{ profileForm.pending }}</p>

  </form>
  <!--
  <label for="firstName">First Name:</label>
  <input id="firstName" formControlName="firstName" placeholder="First Name">
  <label for="lastName">Last Name:</label>
  <input id="lastName" formControlName="lastName" placeholder="Last Name">
  -->
  <input type="text" [(ngModel)]="datoDelPadre" placeholder="Dato del padre" />
  <h2>Pick a highlight color</h2>
  <div>
    <input type="radio" name="colors" (click)="color='lightgreen'">Green
    <input type="radio" name="colors" (click)="color='yellow'">Yellow
    <input type="radio" name="colors" (click)="color='cyan'">Cyan
  </div>
  <p appHighlight>Directiva que no recibe parametro</p>
  <p [appHighlight]="color">Directiva que SI recibe parametro</p>
  <p [appHighlight]="color" defaultColor="violet">Directiva que recibe un parametro dinamico y uno estatico</p>
  <p [appHighlight]="color" [defaultColor]="color">Directiva que recibe un parametro dinamico y uno dinamico</p>


  <input type="text" [(ngModel)]="datoDelPadreInicialSignal" placeholder="Dato del padre signal" />
  <p>Hola dato del padre signal, {{ datoDelPadreInicialSignal }}!</p>

  <div class="row">
    <app-test-hijo-angular
      [(inputProperty)]="datoDelPadre"
      [(inputPropertySignal)]="datoDelPadreInicialSignal"
      [usuario]="filaUsuarioSeleccionado" >
    </app-test-hijo-angular>
  </div>

</div>
